import { useState, useEffect } from "react";
import { changeWithdrawStatus, changeOldAgeWithdrawStatus, changeOldAgeFinalWithdrawStatus } from "../../services/apiService";
import { TbFileDownload } from "react-icons/tb";
import { BsBank } from "react-icons/bs";
import instance from "../../services/endpoint";
import { Pagination } from "react-bootstrap";
import { toast } from "react-toastify";
import CustomDropdown from "../utilComponents/customDropDown.js";
import Loader from "../utilComponents/loader"; // Import Loader component from utilComponents folder
import ShimmerLoader from "../utilComponents/shimmer.js";
import { useAllWithdrawRequests } from "../../services/hooks/getSuperAdminApis.js";
import "../../styles/withdrawmanagement.css";

const WithdrawRequests = ({ searchQuery }) => {
  const [withdrawRequests, setWithdrawRequests] = useState([]);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [accountID, setAccountID] = useState(""); // State to store Account ID for finding user withdrawal details
  const [userWithdrawDetails, setUserWithdrawDetails] = useState(null); // State to store user withdrawal details
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [findLoading, setFindLoading] = useState(false); // Track loading state for finding user withdrawal details
  const itemsPerPage = 5; // Items per page

  const { data: withdrawRequestsData, isLoading } = useAllWithdrawRequests();

  useEffect(() => {
    if (
      withdrawRequestsData &&
      typeof withdrawRequestsData === "object" &&
      Array.isArray(withdrawRequestsData.withdrawRequests)
    ) {
      setWithdrawRequests(withdrawRequestsData.withdrawRequests.reverse());
      console.log("Withdraw Requests:", withdrawRequestsData.withdrawRequests);
    }
  }, [withdrawRequestsData]);


  // Function to change withdrawal status normal account
  const handleWithdrawStatusChange = async (accountID, id, updatedStatus) => {
    if (!updatedStatus) {
      toast.info("Please select a status");
      return;
    }
    setLoadingButtons((prev) => ({ ...prev, [id]: true }));
    try {
      await changeWithdrawStatus(accountID, id, updatedStatus);
      toast.success("Withdrawal status updated successfully");
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Error updating withdrawal status"
      );
      console.error(err);
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [id]: false }));
    }
  };

  // Function to change withdrawal status old age account
  const handleOldAgeWithdrawStatusChange = async (accountID, id, updatedStatus, month, amount) => {
    if (!updatedStatus) {
      toast.info("Please select a status");
      return;
    }
    setLoadingButtons((prev) => ({ ...prev, [id]: true }));
    try {
      await changeOldAgeWithdrawStatus(accountID, id, updatedStatus, month, amount);
      toast.success("Withdrawal status updated successfully");
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Error updating withdrawal status"
      );
      console.error(err);
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [id]: false }));
    }
  };

  // Function to handle final withdrawal status change oldage account
  const handleOldAgeFinalWithdrawStatusChange = async (accountID, id, updatedStatus) => {
    if (!updatedStatus) {
      toast.info("Please select a status");
      return;
    }
    setLoadingButtons((prev) => ({ ...prev, [id]: true }));
    try {
      await changeOldAgeFinalWithdrawStatus(accountID, id, updatedStatus);
      toast.success("Withdrawal status updated successfully");
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Error updating withdrawal status"
      );
      console.error(err);
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [id]: false }));
    }
  };

  const handleStatusChange = (id, value) => {
    setWithdrawRequests((prevRequests) =>
      prevRequests.map((request) =>
        request._id === id ? { ...request, status: value } : request
      )
    );
  };

  const filteredRequests = withdrawRequests.filter(
    (request) =>
      request.AccountID.toLowerCase().includes(searchQuery.toLowerCase()) ||
      request.withdraw_mode.toLowerCase().includes(searchQuery.toLowerCase()) ||
      request.amount.toString().includes(searchQuery) ||
      request.status.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // download csv data file=====================
const downloadCSV = () => {
  const headers = [
    "Account ID",
    "Withdraw Mode",
    "Completed Months",
    "Deposited Amount",
    "Withdraw Period",
    "Withdraw Amount",
    "Status"
  ];

  const escapeCSV = (value) => {
    if (value === null || value === undefined) return '""';
    const str = value.toString();
    return `"${str.replace(/"/g, '""')}"`; // Escape double quotes and wrap in quotes
  };

  const rows = filteredRequests.map((req) => [
    escapeCSV(req.AccountID),
    escapeCSV(req.withdraw_mode),
    escapeCSV(req.month),
    escapeCSV(`₹${req.depositedAmount}`),
    escapeCSV(req.withdrawPeriod),
    escapeCSV(`₹${req.amount}`),
    escapeCSV(req.status),
  ]);

  const csvContent = [headers.map(escapeCSV), ...rows]
    .map((row) => row.join(","))
    .join("\n");

  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" }); // Optional BOM for Excel
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", "withdraw_requests.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  // ============================================

  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredRequests.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const pending = withdrawRequests.filter(
    (request) => request.status === "Pending"
  ).length;

  // popup to find user withdraw details====================
  const [isPopupOpen, setIsPopupOpen] = useState(false); // State to manage popup visibility

  const openPopup = () => {
    setIsPopupOpen(true); // Open the popup
  };

  const closePopup = () => {
    setIsPopupOpen(false); // Close the popup
  };

  // Function to find user withdrawal details by Account ID
  const findWithdrawDetails = async () => {
    console.log(accountID);
    const trimmedAccountID = accountID.trim(); // Trim white spaces
    if (!trimmedAccountID) {
      toast.info("Please enter an Account ID");
      return;
    }
    setFindLoading(true);
    try {
      const response = await instance.post(
        "/api/v1/withdrawDetails/findWithdrawDetails",
        {
          AccountID: trimmedAccountID,
        }
      );
      setUserWithdrawDetails(response.data.decryptedWithdrawData);
      // console.log("user withdraw Details",userWithdrawDetails);
    } catch (err) {
      toast.error("Error finding withdrawal details");
      console.error(err);
    } finally {
      setFindLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div>
        <h2>Withdraw Requests</h2>
        <div className="csv">
          {pending === 0 ? (
            <p style={{ color: "green" }}>No Pending Requests</p>
          ) : (
            <p style={{ color: "red" }}>Total Pending Requests: {pending}</p>
          )}

          <div style={{ alignSelf: "flex-end" }}>
            <button onClick={openPopup} className="downloadBtn">
              <BsBank />
            </button>
            <button onClick={downloadCSV} className="downloadBtn">
              <TbFileDownload />
            </button>
          </div>
        </div>

        <div className="scrollable-table">
          <table>
            <thead>
              <tr>
                <th>Account ID</th>
                <th>Withdraw Mode</th>
                <th>Completed Months</th>
                <th>Deposited Amount</th>
                <th>Withdraw Period</th>
                <th>Withdraw Amount</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(currentItems) && currentItems.length > 0 ? (
                currentItems.map((request) => (
                  <tr key={request._id}>

                    {request.oldAge ? (
                      <td style={{ position: "relative" }}>
                        <div className="corner-ribbon">OldAge Acc</div>

                        {request.AccountID}
                      </td>
                    ) : (
                      <td>{request.AccountID}</td>
                    )}

                    <td>{request.withdraw_mode}</td>
                    <td>{request.month}</td>
                    <td>₹{request.depositedAmount}</td>
                    <td>{request.withdrawPeriod}</td>
                    <td>₹{request.amount}</td>
                    <td>{request.status}</td>
                    <td>
                      <div>
                        <CustomDropdown
                          options={["Approved", "Declined"]}
                          selected={request.status}
                          onSelect={(value) =>
                            handleStatusChange(request._id, value)
                          }
                        />
                      </div>
                      {/* checking which status is selected oldage or normal account */}
                      {(request.oldAge || request.isPartialWithdraw) && request.depositedAmount !== request.particularReturn ? (
                        //old age monthly withdraw request
                         <button
                        onClick={() =>
                          handleOldAgeWithdrawStatusChange(
                            request.AccountID,
                            request._id,
                            request.status,
                            request.month,
                            request.particularReturn
                          )
                        }
                        disabled={loadingButtons[request._id]}>
                        {loadingButtons[request._id]
                          ? "Updating..."
                          : "Update Status"}
                      </button>
                      ) : (request.oldAge || request.isPartialWithdraw) && request.depositedAmount === request.particularReturn ? (
                        //old final withdraw request
                        <button
                        onClick={() =>
                          handleOldAgeFinalWithdrawStatusChange(
                            request.AccountID,
                            request._id,
                            request.status
                          )
                        }
                        disabled={loadingButtons[request._id]}>
                        {loadingButtons[request._id]
                          ? "Updating..."
                          : "Update Status"}
                      </button>
                      ) : (
                        //normal account===
                      <button
                        onClick={() =>
                          handleWithdrawStatusChange(
                            request.AccountID,
                            request._id,
                            request.status
                          )
                        }
                        disabled={loadingButtons[request._id]}>
                        {loadingButtons[request._id]
                          ? "Updating..."
                          : "Update Status"}
                      </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                <tr>
                  <td colSpan="9">
                    <ShimmerLoader width="100%" height="30px" />
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="9">No deposit requests found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-center mt-3">
          <Pagination>
            {[...Array(totalPages)].map((_, pageIndex) => (
              <Pagination.Item
                key={pageIndex}
                active={currentPage === pageIndex + 1}
                onClick={() => handlePageChange(pageIndex + 1)}>
                {pageIndex + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
        {/* // Popup for finding user withdrawal details */}
        {isPopupOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="modal-close-button" onClick={closePopup}>
                x
              </button>
              <div>
                <h3>Find User Withdrawal Details with AccountID</h3>
                <input
                  type="text"
                  inputMode="numeric"
                  className="withdrawDetailsInput"
                  value={accountID}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setAccountID(value);
                    }
                  }}
                  placeholder="Enter Account ID"
                  required
                />
                <button
                  onClick={findWithdrawDetails}
                  className="withdrawDetailsBtn"
                  style={{ cursor: findLoading ? "progress" : "pointer" }}>
                  {findLoading ? "finding..." : "Find"}
                </button>
                {userWithdrawDetails && (
                  <div className="withdraw-details">
                    <h4>User Withdrawal Details</h4>
                    <p>
                      <strong>Account Holder Name:</strong>{" "}
                      {userWithdrawDetails.account_holder_name}
                    </p>
                    <p>
                      <strong>Account Number:</strong>{" "}
                      {userWithdrawDetails.account_number}
                    </p>
                    <p>
                      <strong>Bank Account Currency:</strong>{" "}
                      {userWithdrawDetails.bank_account_currency}
                    </p>
                    <p>
                      <strong>BIC/Swift Code:</strong>{" "}
                      {userWithdrawDetails.bic_swift_code}
                    </p>
                    <p>
                      <strong>Branch:</strong> {userWithdrawDetails.branch}
                    </p>
                    <p>
                      <strong>BTC Withdraw Address:</strong>{" "}
                      {userWithdrawDetails.btc_withdraw_address}
                    </p>
                    <p>
                      <strong>ETH Withdraw Address:</strong>{" "}
                      {userWithdrawDetails.eth_withdraw_address}
                    </p>
                    <p>
                      <strong>IFSC Code:</strong>{" "}
                      {userWithdrawDetails.ifsc_code}
                    </p>
                    <p>
                      <strong>Netteller Address:</strong>{" "}
                      {userWithdrawDetails.netteller_address}
                    </p>
                    <p>
                      <strong>UPI Address:</strong>{" "}
                      {userWithdrawDetails.upi_address}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {/* ================================================ */}
      </div>
    </>
  );
};

export default WithdrawRequests;
